<h2 mat-dialog-title>{{ 'DIALOGS.GROUPER.title' | translate }}</h2>
<mat-dialog-content class="mat-typography" style="display: grid">
  <app-select [(ngModel)]="selectedGroupers" multiple>
    <app-select-label>{{ 'DIALOGS.GROUPER.label' | translate }}</app-select-label>
    @for (grouper of groupers; track grouper) {
      <mat-option [value]="grouper">
        {{ grouper | label:'groupers' | async }}
      </mat-option>
    }
  </app-select>
</mat-dialog-content>

<app-button-group>
  <button [mat-dialog-close]="null" color="warn" mat-raised-button>{{ 'QUERY_BUILDER.close' | translate }}</button>
  <button [mat-dialog-close]="selectedGroupers" color="primary" mat-raised-button>{{ 'COMMON.accept' | translate }}</button>
</app-button-group>
